import { Outlet } from "react-router-dom";
import { Header, Footer } from "./index";

export const PublicLayout = () => {
  return (
    <>
      <Header />
      <main className="min-vh-100">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
